var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var EntityDatasource = /** @class */ (function () {
    function EntityDatasource(httpClient, baseUrl) {
        if (baseUrl === void 0) { baseUrl = process.env.ENTITY_URL; }
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
    }
    EntityDatasource.prototype.addEmployeeRole = function (_a) {
        var rockId = _a.rockId, role = _a.role, employeeRockId = _a.employeeRockId;
        return this.httpClient
            .request({
            method: "POST",
            baseUrl: this.baseUrl,
            url: "/v3/clients/" + rockId + "/employees/" + employeeRockId + "/roles",
            body: {
                role: role,
            },
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    EntityDatasource.prototype.getEntities = function (params) {
        return this.httpClient
            .request({
            method: "GET",
            url: "/v3/entities",
            baseUrl: this.baseUrl,
            params: params,
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    EntityDatasource.prototype.unbindEmployee = function (_a) {
        var rockId = _a.rockId, employeeRockId = _a.employeeRockId;
        return this.httpClient
            .request({
            method: "POST",
            baseUrl: this.baseUrl,
            url: "/v3/clients/" + rockId + "/employees/" + employeeRockId + "/unbind",
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    EntityDatasource.prototype.bindEmployee = function (_a) {
        var rockId = _a.rockId, employeeRockId = _a.employeeRockId;
        return this.httpClient
            .request({
            method: "POST",
            baseUrl: this.baseUrl,
            url: "/v3/clients/" + rockId + "/employees/" + employeeRockId + "/bind",
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    EntityDatasource.prototype.createCompany = function (params) {
        return this.httpClient
            .request({
            method: "POST",
            baseUrl: this.baseUrl,
            url: "/v3/clients",
            body: params,
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    EntityDatasource.prototype.getEmployeesByClient = function (rockId, pagination) {
        return this.httpClient
            .request({
            method: "GET",
            url: "/v3/clients/" + rockId + "/employees",
            baseUrl: this.baseUrl,
            params: __assign({}, pagination),
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    EntityDatasource.prototype.createCompanyEmployee = function (companyRockId, params) {
        return this.httpClient
            .request({
            method: "POST",
            baseUrl: this.baseUrl,
            url: "/v3/clients/" + companyRockId + "/employees",
            body: params,
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    EntityDatasource.prototype.getByRockId = function (rockId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "GET",
                            baseUrl: this.baseUrl,
                            url: "/v3/entities/" + rockId,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    EntityDatasource.prototype.addCompanyAddress = function (rockId, address) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "POST",
                            baseUrl: this.baseUrl,
                            url: "/v3/clients/" + rockId + "/addresses",
                            body: {
                                addresses: [address],
                            },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    EntityDatasource.prototype.getEmployeesDetailed = function (rockId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "GET",
                            baseUrl: this.baseUrl,
                            url: "/v3/employees/detailed",
                            params: {
                                rockId: rockId,
                            },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    EntityDatasource.prototype.updateEntity = function (rockId, entity) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "PATCH",
                            baseUrl: this.baseUrl,
                            url: "/v3/me",
                            body: entity,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    EntityDatasource.prototype.getPersonaPlatforms = function (rockId, personaPath, onlyProductPlatforms) {
        if (onlyProductPlatforms === void 0) { onlyProductPlatforms = true; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "GET",
                            baseUrl: this.baseUrl,
                            url: "/v3/" + personaPath + "/" + rockId + "/platforms",
                            params: {
                                onlyProductPlatforms: onlyProductPlatforms,
                            },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    EntityDatasource.prototype.createTalent = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "POST",
                            baseUrl: this.baseUrl,
                            url: "/v2/talents",
                            body: __assign({}, payload),
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    EntityDatasource.prototype.getCompany = function (rockId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "GET",
                            baseUrl: this.baseUrl,
                            url: "/v3/clients/" + rockId,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    EntityDatasource.prototype.updateClient = function (rockId, client) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "PATCH",
                            baseUrl: this.baseUrl,
                            url: "/v3/clients/" + rockId,
                            body: client,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    EntityDatasource.prototype.getPersonas = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "GET",
                            baseUrl: this.baseUrl,
                            url: "/v3/entities-personas",
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    return EntityDatasource;
}());
export { EntityDatasource };
